import { render, staticRenderFns } from "./RegionManagement.vue?vue&type=template&id=46aef708"
import script from "./RegionManagement.vue?vue&type=script&lang=js"
export * from "./RegionManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports